/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { useQuery } from '@tanstack/react-query';

import { getUserProfile, getUserProviders } from '../../api/user/user.requests';
import { useUserProfileStore } from '../../stores/user-profile/user-profile.store';
import { getAuthToken } from '../../utils/auth';

export const useGetUserAccount = () => {
  const authToken = getAuthToken();
  const { accountStatus } = useUserProfileStore();

  const refreshEnabled = accountStatus === 'no-game-accounts' || accountStatus === 'no-game-ownership';

  const userProfile = useQuery({
    queryKey: ['user.profile'],
    queryFn: () => getUserProfile(),
    refetchOnWindowFocus: refreshEnabled,
    enabled: !!authToken,
  });

  const userProviders = useQuery({
    queryKey: ['user.providers'],
    queryFn: () => getUserProviders(),
    refetchOnWindowFocus: refreshEnabled,
    enabled: !!authToken,
  });

  return { userProfile, userProviders };
};
